import React from 'react';

const HitchTheme = {
  headerLogo: {
    src: '/themes/theme/hitch/logo.png',
    alt: 'Hitch eSports',
  },
  darkLogo: {
    src: '/themes/theme/hitch/logo.png',
    alt: 'Hitch eSports',
  },
  headerStyle: {
    backgroundColor: '#FFF',
    borderBottom: '2px solid #BF0000',
  },
  linkStyle: {
    color: '#000',
    fontWeight: 800,
    fontSize: '120%',
  },
  isLightOnDark: false,
  loginMessage: (
    <div>
      <h3>WHAT IS HITCH eSPORTS?</h3>
      <br />
      <p>Hitch eSports is an online marketplace for professional players, teams and organisations enabling them to present commercial branding opportunities to advertising brands and media groups.</p>
      <br />
      <p>The platform is an invite only, automated, transactional marketplace, allowing parties to review, negotiate and transact within a managed environment, making the process more efficient and accountable.</p>
    </div>
  ),
  shareSite: 'https://hitchr.dyzio.co',
};

export default HitchTheme;



/** WEBPACK FOOTER **
 ** ./src/themes/theme/hitch.js
 **/